export default __webpack_public_path__ + "static/media/partner-ascenders.789d1204.png";